module.exports = __webpack_public_path__ + "img/underground_off.f7661ccf.svg";